import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";

/*
This is an example navbar
*/

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token");
  const role = (localStorage.getItem("role") || "").toLowerCase();

  //Hide navbar on login page
  if (location.pathname === "/login") return null;

  //hide if not logged in
  if (!token) return null;

  const isUser = role === "user";

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("role");

    navigate("/login");
  };
  
  // If you want a different image, you can go to a site like icons8, right-click an image, and copy image address (flaticons.com doesn't support this).
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img src="https://img.icons8.com/?size=100&id=MMXAq1D0nukJ&format=png&color=000000" 
        alt="logo" className="navbar-icon" />
        <span>FixTrack</span>
      </Link>
      

      <div className="nav-links">
        {isUser ? (
          <Link to="/user-tickets" className="nav-item">My Tickets</Link>
        ) : (
          <Link to="/ticket-manager" className="nav-item">Dashboard</Link>
        )}

        <Link to="/Profile" className="nav-item">Profile</Link>

        <button onClick={logout} className="nav-button">
          Logout
        </button>
      </div>
    </nav>
  );
}
